export default __webpack_public_path__ + "static/waterfall-dark-0ad444ef0387828c2bd495c6d18b6f9a.gif";